import axiosInstance from "./AxiosInstance";

export function getPublicSales(latitude, longitude, radius, bounds, startPoint, endPoint, polyline, companySlug) {
  const startP = startPoint && startPoint.location && startPoint.location.length ? { lat: startPoint.location[0], lng: startPoint.location[1] } : null;
  const endP = endPoint && endPoint.location && endPoint.location.length ? { lat: endPoint.location[0], lng: endPoint.location[1] } : null;

  if (polyline) {
    return axiosInstance.post(`/api/sales`, {
      polyline: polyline,
      start_point: startP,
      end_point: endP
    });
  }

  const config = {
    params: {
      location: latitude ? [latitude, longitude] : ['', ''],
      radius: radius || 20,
      bounds: bounds,
      start_point: startP,
      end_point: endP,
      company_slug: companySlug
    }
  };
  return axiosInstance.get(`/api/sales`, config);
}

export function getPublicSale(id) {
  return axiosInstance.get(`/api/sales/${id}`);
}

export function getSaleProducts(id) {
  return axiosInstance.get(`/api/sales/${id}/products`);
}

export function getManagementSales(rest_id) {
  return axiosInstance.get(`/api/management/settings/sales`, { params: { rest_id } });
}

export function createManagementSale(rest_id, saleData) {
  return axiosInstance.post(`/api/management/settings/sales`, saleData, { params: { rest_id } });
}

export function updateManagementSale(rest_id, sale_id, saleData) {
  return axiosInstance.put(`/api/management/settings/sales/${sale_id}`, saleData, { params: { rest_id } });
}

export function deleteManagementSale(rest_id, sale_id) {
  return axiosInstance.delete(`/api/management/settings/sales/${sale_id}`, { params: { rest_id } });
}

export function toggleManagementSale(rest_id, sale_id) {
  return axiosInstance.put(`/api/management/settings/sales/${sale_id}/toggle_active`, {}, { params: { rest_id } });
}

export function destroySalePicture(rest_id, sale_id) {
  return axiosInstance.delete(`/api/management/settings/sales/${sale_id}/destroy_picture`, { params: { rest_id } });
}

export function rateSale(id, kind) {
  return axiosInstance.post(`/api/sales/${id}/rate_sale`, { sale: { kind: kind } });
}

